package org.example.project.engineslot

import org.example.project.service.MeineFahrzeugeApi
import org.example.project.utils.All

suspend fun loadSlotMeineZugmaschinen(): List<All> =
    runCatching { MeineFahrzeugeApi.load(MeineFahrzeugeApi.TYP_ZUGMASCHIENE) }
        .getOrDefault(emptyList())

suspend fun loadSlotMeineAuflieger(): List<All> =
    runCatching { MeineFahrzeugeApi.load(MeineFahrzeugeApi.TYP_AUFLIEGER) }
        .getOrDefault(emptyList())

fun slotVehicleDropdownOptions(
    vehicles: List<All>,
    selectedKennzeichen: String,
    showAufliegerMerkmale: Boolean = false
): List<All> {
    val options = vehicles
        .filter { it.aktiv && it.kennzeichen.isNotBlank() }
        .distinctBy { it.kennzeichen.trim().lowercase() }
        .sortedBy { it.kennzeichen.lowercase() }
        .map { vehicle ->
            All(
                key = vehicle.kennzeichen.trim(),
                label = slotVehicleLabel(vehicle, showAufliegerMerkmale)
            )
        }

    val selected = selectedKennzeichen.trim()
    val selectedOption = if (
        selected.isNotBlank() &&
        options.none { it.key.equals(selected, ignoreCase = true) }
    ) {
        listOf(All(key = selected, label = selected))
    } else {
        emptyList()
    }

    return listOf(All(key = "", label = "Keine Auswahl")) + selectedOption + options
}

private fun slotVehicleLabel(vehicle: All, showAufliegerMerkmale: Boolean): String {
    val basis = listOf(
        vehicle.kennzeichen.trim(),
        vehicle.name.trim()
    ).filter { it.isNotBlank() }

    val merkmale = if (showAufliegerMerkmale) {
        listOf(
            "Koffer" to vehicle.koffer,
            "Planer" to vehicle.planer,
            "Kühlung" to vehicle.kuehlung
        ).filter { it.second }.map { it.first }
    } else {
        emptyList()
    }

    return (basis + merkmale).joinToString(" | ")
}
